import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 充提币相关接口
enum API {
  // 分页查询其他记录
  FinanceOtherLogList = '/hk-web/finance/other/log/list',
  // validateAddress
  CapitalValidateAddress = '/hk-web/capital/validateAddress',
  // withdrawAddressCoin
  CapitalWithdrawAddressCoin = '/hk-web/capital/withdraw_address_coin',
  // 虚拟币提现申请前校验
  CapitalWithdrawCheck = '/hk-web/capital/withdrawCheck',
  // 财务日志个人币种
  FinanceOwnCointypeList = '/hk-web/finance/own/cointype/list',
  // getSystemCoinTypeList
  CapitalGetSystemCoinTypeList = '/hk-web/capital/getSystemCoinTypeList',
  // 查询符合地址类型的网络
  CapitalGetNetworkByAddr = '/hk-web/capital/getNetworkByAddr',
  // 根据币种id和地址查询提现地址
  CapitalCreateWithdrawAddress1659664748250 = '/hk-web/capital/create_withdraw_address_1659664748250',
  // getWithdrawAddress
  CapitalQueryWithdrawAddress = '/hk-web/capital/query_withdraw_address',
  // 分页查询合约邀请返佣记录
  FinanceContractCommissionLogList = '/hk-web/finance/contract_commission/log/list',
  // 分页统计合约邀请返佣记录
  FinanceContractCommissionSumList = '/hk-web/finance/contract_commission/sum/list',
  // 获取选中充币地址
  RechargeCoinAddress = '/hk-web/recharge/coin_address',
  // 新增虚拟币充值地址
  RechargeAddressCreate = '/hk-web/recharge/address/create',
  // 获取充币地址列表
  RechargeAddressList = '/hk-web/recharge/address/list',
  // 编辑充币地址名称
  RechargeAddressRemark = '/hk-web/recharge/address/remark',
  // 选用当前充币地址
  RechargeAddressSelected = '/hk-web/recharge/address/selected',
  // 内部转账转账前校验
  CapitalTransferPrecheck = '/hk-web/capital/transfer/precheck',
  // 内部转账提交(包括4项验证)
  CapitalTransferSubmit = '/hk-web/capital/transfer/submit',
  // 虚拟币提现申请前校验V1
  V1CapitalWithdrawCheck = '/hk-web/v1/capital/withdrawCheck',
  // 分页根据类型查询其他记录
  FinanceOtherByTypeLogList = '/hk-web/finance/other_by_type/log/list',
  // 查询支持通用提现地址的网络列表
  CapitalUniversalAddressNetworks = '/hk-web/capital/universal_address/networks',
  // 编辑提现地址设置
  CapitalWithdrawEditAddressSetting = '/hk-web/capital/withdraw/edit_address_setting',
  // 查询提现地址设置
  CapitalWithdrawGetAddressSetting = '/hk-web/capital/withdraw/get_address_setting',
  // 查询最近充提记录列表
  FinanceRechargeWithdrawList = '/hk-web/finance/recharge_withdraw/list',
  // 编辑提现地址设置
  TestCapitalWithdrawEditAddressSetting = '/hk-web/test/capital/withdraw/edit_address_setting',
  // 根据币种查询提币地址
  V3CapitalListWithdrawAddress = '/hk-web/v3/capital/list_withdraw_address',
  // 地址簿分页查询查询提现地址
  CapitalWithdrawAddressList = '/hk-web/capital/withdraw_address/list',
  // 编辑提现地址备注
  CapitalWithdrawAddressRemarkEdit = '/hk-web/capital/withdraw_address/remark_edit',
  // 分页查询空投(startup分发、startup认购)记录
  FinanceAirdropLogList = '/hk-web/finance/airdrop/log/list',
  // 查询用户钱包划转记录
  FinanceTransferHistoryList = '/hk-web/finance/transfer/history/list',
  // 资金划转类型列表
  WalletTransferTypes = '/hk-web/wallet/transfer/types',
  // 查询划转账户类型
  TransferGetType = '/hk-web/transfer/getType',
  // 查询所有账户详情
  WalletTransferInfos = '/hk-web/wallet/transfer/infos',
  // 资金划转类型列表V1
  V1WalletTransferTypes = '/hk-web/v1/wallet/transfer/types',
  // 分页查询充币记录
  FinanceRechargeLogList = '/hk-web/finance/recharge/log/list',
  // 分页查询划转记录
  FinanceTransferLogList = '/hk-web/finance/transfer/log/list',
  // 分页查询提币记录
  FinanceWithdrawLogList = '/hk-web/finance/withdraw/log/list',
  // 分页查询提币地址
  V2CapitalListWithdrawAddress = '/hk-web/v2/capital/list_withdraw_address',
  // createWithdrawAddress
  CapitalCreateWithdrawAddress = '/hk-web/capital/create_withdraw_address',
  // 提币撤销
  WithdrawCancel = '/hk-web/withdraw/cancel',
  // 提币地址校验
  V2CapitalValidateAddress = '/hk-web/v2/capital/validateAddress',
  // 删除提币地址
  V2CapitalRemoveWithdrawAddress = '/hk-web/v2/capital/remove_withdraw_address',
  // 获取提币所需参数
  V2CapitalCoinWithdrawInfo = '/hk-web/v2/capital/coin_withdraw_info',
  // 虚拟币提现申请(包括4项验证)
  CapitalWithdraw = '/hk-web/capital/withdraw',
  // 查询可提现币种信息
  ListWithdrawCoin = '/hk-web/list_withdraw_coin',
  // 获取可划转币种列表
  TransferInfo = '/hk-web/transfer/info',
  // 查询用户钱包信息
  WalletInfo = '/hk-web/wallet/info',
}

export type TGetFinanceOtherLogListParams = {
  coinId?: number // 查询条件 币种id
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  timeRange?: number // 查询条件 时间范围(1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceOtherLogListResponse = TResponse<any[]>
export const getFinanceOtherLogList = (params?: TGetFinanceOtherLogListParams) => {
  return hcAxios.get<TGetFinanceOtherLogListResponse>(API.FinanceOtherLogList, { params })
}

export type TPostCapitalValidateAddressParams = {}
export type TPostCapitalValidateAddressResponse = TResponse<any>
export const postCapitalValidateAddress = (params?: TPostCapitalValidateAddressParams) => {
  return hcAxios.post<TPostCapitalValidateAddressResponse>(API.CapitalValidateAddress, params)
}

export type TPostCapitalWithdrawAddressCoinParams = any
export type TPostCapitalWithdrawAddressCoinResponse = TResponse<any>
export const postCapitalWithdrawAddressCoin = (params?: TPostCapitalWithdrawAddressCoinParams) => {
  return hcAxios.post<TPostCapitalWithdrawAddressCoinResponse>(API.CapitalWithdrawAddressCoin, params)
}

export type TGetCapitalWithdrawCheckParams = any
export type TGetCapitalWithdrawCheckResponse = TResponse<any>
export const getCapitalWithdrawCheck = (params?: TGetCapitalWithdrawCheckParams) => {
  return hcAxios.get<TGetCapitalWithdrawCheckResponse>(API.CapitalWithdrawCheck, { params })
}

export type TGetCapitalValidateAddressParams = {
  address?: any // address
  coinId?: any // coinId
  memo?: any // memo
  scene?: any // scene
}
export type TGetCapitalValidateAddressResponse = TResponse<any>
export const getCapitalValidateAddress = (params?: TGetCapitalValidateAddressParams) => {
  return hcAxios.get<TGetCapitalValidateAddressResponse>(API.CapitalValidateAddress, { params })
}

export type TGetFinanceOwnCointypeListParams = any
export type TGetFinanceOwnCointypeListResponse = TResponse<
  {
    coinId?: number // 币种id
    coinShortName?: string // 币种
    name?: string // 币种全称
    webLogo?: string // 币种LOGO
  }[]
>
export const getFinanceOwnCointypeList = (params?: TGetFinanceOwnCointypeListParams) => {
  return hcAxios.get<TGetFinanceOwnCointypeListResponse>(API.FinanceOwnCointypeList, { params })
}

export type TGetCapitalGetSystemCoinTypeListParams = any
export type TGetCapitalGetSystemCoinTypeListResponse = TResponse<any[]>
export const getCapitalGetSystemCoinTypeList = (params?: TGetCapitalGetSystemCoinTypeListParams) => {
  return hcAxios.get<TGetCapitalGetSystemCoinTypeListResponse>(API.CapitalGetSystemCoinTypeList, { params })
}

export type TPostCapitalGetSystemCoinTypeListParams = any
export type TPostCapitalGetSystemCoinTypeListResponse = TResponse<any[]>
export const postCapitalGetSystemCoinTypeList = (params?: TPostCapitalGetSystemCoinTypeListParams) => {
  return hcAxios.post<TPostCapitalGetSystemCoinTypeListResponse>(API.CapitalGetSystemCoinTypeList, params)
}

export type TGetCapitalGetNetworkByAddrParams = {
  address?: any // address
  coinId?: any // coinId
}
export type TGetCapitalGetNetworkByAddrResponse = TResponse<{
  domainAddress?: string // 域名解析地址
  isDomainAddress?: boolean // 地址是否为域名 true-是 false-否
  isPlatformTransfer?: boolean // 是否平台互转 true 是 false 否 有一个主网校验结果为true时为true
  isValidateAddress?: boolean // 是否校验地址通过 true是 false否 仅当全部主网校验结果为false时为false
  list?: {
    arrivalTime?: number // 预计到账时间(分钟)
    coinId?: number // 币种
    domainAddress?: string // 域名解析地址
    fee?: string // 手续费
    isCongested?: boolean // 网络拥堵 true 是 false 否
    isDomainAddress?: boolean // 地址是否为域名 true-是 false-否
    isPercentage?: boolean // 是否百分比收手续费 true 是 false 否
    isPlatformTransfer?: boolean // 是否平台互转 true 是 false 否
    isPlatformTransferFee?: boolean // 是否平台互转收手续费 true 是 false 否
    isUseMemo?: boolean // 是否使用地址标签 true 是 false 否
    isValidateAddress?: boolean // 是否校验地址通过 true是 false否
    isWithdraw?: boolean // 是否允许提现 true是 false否
    networkName?: string // 网络名称
    symbol?: string // 币种symbol
  }[] // 手续费
}>
export const getCapitalGetNetworkByAddr = (params?: TGetCapitalGetNetworkByAddrParams) => {
  return hcAxios.get<TGetCapitalGetNetworkByAddrResponse>(API.CapitalGetNetworkByAddr, { params })
}

export type TPostCapitalCreateWithdrawAddress1659664748250Params = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalCreateWithdrawAddress1659664748250Response = TResponse<{
  fadderess?: string // 虚拟币地址
  fcoinid?: number // 虚拟币ID
  fcreatetime?: number // 创建时间
  fid?: number // 主键ID
  fuid?: number // 用户ID
  fremark?: string // 备注
  isVerified?: string // 是否免认证 false-否 true-是
}>
export const postCapitalCreateWithdrawAddress1659664748250 = (
  params?: TPostCapitalCreateWithdrawAddress1659664748250Params
) => {
  return hcAxios.post<TPostCapitalCreateWithdrawAddress1659664748250Response>(
    API.CapitalCreateWithdrawAddress1659664748250,
    params
  )
}

export type TPostCapitalQueryWithdrawAddressParams = {
  coinId: number
  withdrawaddress: string
}
export type TPostCapitalQueryWithdrawAddressResponse = TResponse<string>
export const postCapitalQueryWithdrawAddress = (params?: TPostCapitalQueryWithdrawAddressParams) => {
  return hcAxios.post<TPostCapitalQueryWithdrawAddressResponse>(API.CapitalQueryWithdrawAddress, params)
}

export type TGetFinanceContractCommissionLogListParams = {
  coinId?: number // 查询条件 币种id
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  timeRange?: number // 查询条件 时间范围(1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceContractCommissionLogListResponse = TResponse<any[]>
export const getFinanceContractCommissionLogList = (params?: TGetFinanceContractCommissionLogListParams) => {
  return hcAxios.get<TGetFinanceContractCommissionLogListResponse>(API.FinanceContractCommissionLogList, { params })
}

export type TGetFinanceContractCommissionSumListParams = {
  coinId?: number // 查询条件 币种id
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  timeRange?: number // 查询条件 时间范围(1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceContractCommissionSumListResponse = TResponse<any[]>
export const getFinanceContractCommissionSumList = (params?: TGetFinanceContractCommissionSumListParams) => {
  return hcAxios.get<TGetFinanceContractCommissionSumListResponse>(API.FinanceContractCommissionSumList, { params })
}

export type TPostRechargeCoinAddressParams = {
  symbol?: number // 币种id
}
export type TPostRechargeCoinAddressResponse = TResponse<{
  fadderess?: string
  fcoinid?: number
  fcreatetime?: number
  fid?: number
  fuid?: number
  isUseMemo?: boolean
  rechargeWarnWord?: string
  selected?: boolean
}>
export const postRechargeCoinAddress = (params?: TPostRechargeCoinAddressParams) => {
  return hcAxios.post<TPostRechargeCoinAddressResponse>(API.RechargeCoinAddress, params)
}

export type TGetRechargeAddressCreateParams = {
  symbol: number // 币种id
}
export type TGetRechargeAddressCreateResponse = TResponse<{
  symbol?: number // 币种id
}>
export const getRechargeAddressCreate = (params?: TGetRechargeAddressCreateParams) => {
  return hcAxios.get<TGetRechargeAddressCreateResponse>(API.RechargeAddressCreate, { params })
}

export type TPostRechargeAddressListParams = {
  symbol?: number // 币种id
  contentType?: number
  signature?: string
}
export type TPostRechargeAddressListResponse = TResponse<
  {
    fid: number // 主键ID
    fcoinid: number // 虚拟币ID
    fadderess?: string // 虚拟币地址
    memo?: string // 地址标签
    rechargeWarnWord?: string // 充值提示语
    fcreatetime: number // 创建时间
    isUseMemo?: boolean // 是否使用地址标签
    fshortname?: string // 币种名称
    selected?: boolean // 是否当前选用 0-否 1-是
    remark?: string // 地址名称
  }[]
>
export const postRechargeAddressList = (params?: TPostRechargeAddressListParams) => {
  return hcAxios.post<TPostRechargeAddressListResponse>(API.RechargeAddressList, params)
}

export type TPostRechargeAddressRemarkParams = {
  fid?: number // 主键ID
  remark?: string // 地址名称
}
export type TPostRechargeAddressRemarkResponse = TResponse<{}>
export const postRechargeAddressRemark = (params?: TPostRechargeAddressRemarkParams) => {
  return hcAxios.post<TPostRechargeAddressRemarkResponse>(API.RechargeAddressRemark, params)
}

export type TPostRechargeAddressSelectedParams = {
  fid?: number // 主键ID
  fcoinid?: number // 虚拟币ID
}
export type TPostRechargeAddressSelectedResponse = TResponse<any>
export const postRechargeAddressSelected = (params?: TPostRechargeAddressSelectedParams) => {
  return hcAxios.post<TPostRechargeAddressSelectedResponse>(API.RechargeAddressSelected, params)
}

export type TPostCapitalTransferPrecheckParams = {
  address?: string // 转账信息 邮箱 手机号 uid
  addressType?: number // 转账地址类型 1-邮箱 2-手机号码 3-UID
  amount?: string // 提现数量
  areaCode?: string // 手机号码区号
  coinId?: number // 币种id
}
export type TPostCapitalTransferPrecheckResponse = TResponse<{
  amountInCny?: string // 数量折合CNY
  transferUserId?: number // 收款用户ID
}>
export const postCapitalTransferPrecheck = (params?: TPostCapitalTransferPrecheckParams) => {
  return hcAxios.post<TPostCapitalTransferPrecheckResponse>(API.CapitalTransferPrecheck, params)
}

export type TPostCapitalTransferSubmitParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalTransferSubmitResponse = TResponse<{
  address?: string // 转账信息 邮箱 手机号 uid
  amount?: string // 提现数量
  areaCode?: string // 手机号码区号
  remark?: string // 备注
}>
export const postCapitalTransferSubmit = (params?: TPostCapitalTransferSubmitParams) => {
  return hcAxios.post<TPostCapitalTransferSubmitResponse>(API.CapitalTransferSubmit, params)
}

export type TPostV1CapitalWithdrawCheckParams = {
  amount?: string // 提现数量
  coinId?: number // 币种id
}
export type TPostV1CapitalWithdrawCheckResponse = TResponse<{
  amountInCny?: string // 数量折合CNY
}>
export const postV1CapitalWithdrawCheck = (params?: TPostV1CapitalWithdrawCheckParams) => {
  return hcAxios.post<TPostV1CapitalWithdrawCheckResponse>(API.V1CapitalWithdrawCheck, params)
}

export type TGetFinanceOtherByTypeLogListParams = {
  coinId?: any // 查询条件 币种id
  count?: any // 是否返回总记录数，默认true
  endTime?: any // 结束时间
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  srcType?: any // 类型(9-创新区解冻、10-创新区分红、12-创新区分红奖励、21-空投糖果、23-发红包、24-收红包、25-退还红包、26-扣除红包、40-代理商佣金、60-手工充值、61-带单分润、62-合约自返佣、70-IGO申购、71-IGO分发、72-NFT购买、73-NFT出售、74-NFT手续费、75-NFT版权费、80-Startup认购、81-Startup分发、82-双币理财申购、83-双币理财回款、84-体验金收益)
  srcTypes?: any // 类型(9-创新区解冻、10-创新区分红、12-创新区分红奖励、21-空投糖果、23-发红包、24-收红包、25-退还红包、26-扣除红包、40-代理商佣金、60-手工充值、61-带单分润、62-合约自返佣、70-IGO申购、71-IGO分发、72-NFT购买、73-NFT出售、74-NFT手续费、75-NFT版权费、80-Startup认购、81-Startup分发、82-双币理财申购、83-双币理财回款、84-体验金收益)
  startTime?: any // 开始时间
  timeRange?: any // 查询条件 时间范围(0：自定义时间，1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceOtherByTypeLogListResponse = TResponse<any[]>
export const getFinanceOtherByTypeLogList = (params?: TGetFinanceOtherByTypeLogListParams) => {
  return hcAxios.get<TGetFinanceOtherByTypeLogListResponse>(API.FinanceOtherByTypeLogList, { params })
}

export type TGetCapitalUniversalAddressNetworksParams = {
  address?: any // address
}
export type TGetCapitalUniversalAddressNetworksResponse = TResponse<{
  domainAddress?: string // 域名解析地址
  isDomainAddress?: boolean // 地址是否为域名 true-是 false-否
  isPlatformTransfer?: boolean // 是否平台互转 true 是 false 否 有一个主网校验结果为true时为true
  isValidateAddress?: boolean // 是否校验地址通过 true是 false否 仅当全部主网校验结果为false时为false
  list?: {
    arrivalTime?: number // 预计到账时间(分钟)
    coinId?: number // 币种
    domainAddress?: string // 域名解析地址
    fee?: string // 手续费
    isCongested?: boolean // 网络拥堵 true 是 false 否
    isDomainAddress?: boolean // 地址是否为域名 true-是 false-否
    isPercentage?: boolean // 是否百分比收手续费 true 是 false 否
    isPlatformTransfer?: boolean // 是否平台互转 true 是 false 否
    isPlatformTransferFee?: boolean // 是否平台互转收手续费 true 是 false 否
    isUseMemo?: boolean // 是否使用地址标签 true 是 false 否
    isValidateAddress?: boolean // 是否校验地址通过 true是 false否
    isWithdraw?: boolean // 是否允许提现 true是 false否
    networkName?: string // 网络名称
    symbol?: string // 币种symbol
  }[] // 手续费
}>
export const getCapitalUniversalAddressNetworks = (params?: TGetCapitalUniversalAddressNetworksParams) => {
  return hcAxios.get<TGetCapitalUniversalAddressNetworksResponse>(API.CapitalUniversalAddressNetworks, { params })
}

export type TPostCapitalWithdrawEditAddressSettingParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalWithdrawEditAddressSettingResponse = TResponse<string>
export const postCapitalWithdrawEditAddressSetting = (params?: TPostCapitalWithdrawEditAddressSettingParams) => {
  return hcAxios.post<TPostCapitalWithdrawEditAddressSettingResponse>(API.CapitalWithdrawEditAddressSetting, params)
}

export type TGetCapitalWithdrawGetAddressSettingParams = any
export type TGetCapitalWithdrawGetAddressSettingResponse = TResponse<{
  addressWhitelist?: number // 地址白名单模式，1为打开，0为关闭
  newAddressLock?: number // 新地址提币锁定，1为打开，0为关闭
}>
export const getCapitalWithdrawGetAddressSetting = (params?: TGetCapitalWithdrawGetAddressSettingParams) => {
  return hcAxios.get<TGetCapitalWithdrawGetAddressSettingResponse>(API.CapitalWithdrawGetAddressSetting, { params })
}

export type TGetFinanceRechargeWithdrawListParams = any
export type TGetFinanceRechargeWithdrawListResponse = TResponse<any[]>
export const getFinanceRechargeWithdrawList = (params?: TGetFinanceRechargeWithdrawListParams) => {
  return hcAxios.get<TGetFinanceRechargeWithdrawListResponse>(API.FinanceRechargeWithdrawList, { params })
}

export type TPostTestCapitalWithdrawEditAddressSettingParams = {
  accessKeyId?: string
  addressWhitelist?: number // 地址白名单模式，1为打开，0为关闭
  addressWhitelistBool?: boolean
  emailCode?: string // 邮箱验证码
  googleCode?: string // google验证码
  newAddressLock?: number // 新地址提币锁定，1为打开，0为关闭
  newAddressLockBool?: boolean
  operateType?: string // 操作类型 开启地址白名单模式-withdraw_address_whitelist_enable  关闭地址白名单模式-withdraw_address_whitelist_disable  开启新地址提币锁定-withdraw_new_address_lock_enable  关闭新地址提币锁定-withdraw_new_address_lock_disable
  phoneCode?: string // 手机验证码
  signature?: string
  signatureMethod?: string
  signatureVersion?: string
  timestamp?: string
  tradePwd?: string // tradePwd
}
export type TPostTestCapitalWithdrawEditAddressSettingResponse = TResponse<{
  addressWhitelist?: number // 地址白名单模式，1为打开，0为关闭
  newAddressLock?: number // 新地址提币锁定，1为打开，0为关闭
}>
export const postTestCapitalWithdrawEditAddressSetting = (
  params?: TPostTestCapitalWithdrawEditAddressSettingParams
) => {
  return hcAxios.post<TPostTestCapitalWithdrawEditAddressSettingResponse>(
    API.TestCapitalWithdrawEditAddressSetting,
    params
  )
}

export type TPostV3CapitalListWithdrawAddressParams = {
  coinId: number
}
export type TPostV3CapitalListWithdrawAddressResponse = TResponse<{
  newAddressLockNum: number // 新地址锁定数量
  list: {
    addressType: number
    chainName: string
    fadderess: string
    fcoinid: number
    fcreatetime: number
    fid: number
    fremark: string
    fuid: number
    init: boolean
    isCollectFee: boolean
    isVerified: boolean
    isWithdraw: boolean
    shortName: string
    signature: string
    status: number
    transferMode: number
    universalType: boolean
    version: number
    webLogo: string
    memo?: string
  }[]
}>
export const postV3CapitalListWithdrawAddress = (params?: TPostV3CapitalListWithdrawAddressParams) => {
  return hcAxios.post<TPostV3CapitalListWithdrawAddressResponse>(API.V3CapitalListWithdrawAddress, params)
}

export type TPostCapitalWithdrawAddressListParams = {
  randomKey?: string // 随机密钥
  randomIv?: string // 随机向量
  bizData?: string // 加密后的业务数据
  signature?: string // 签名串
  timestamp?: string // 时间戳
}
export type TPostCapitalWithdrawAddressListResponse = TResponse<{
  newAddressLockNum?: number // 新地址锁定数量
  list?: {
    fid?: number // 主键ID
    fcoinid?: number // 虚拟币ID
    status?: number // 状态 1启用 2禁用
    isWithdraw?: boolean // 是否提现
    fadderess?: string // 虚拟币地址
    fcreatetime?: number // 创建时间
    fremark?: string // 备注
    memo?: any // 地址标签
    webLogo?: string // WEB站LOGO
    shortName?: string // 简称
    chainName?: string // 链名称
    isVerified?: boolean // 是否免认证 false-否 true-是
    addressLockedUntil?: any // 新地址提现锁定截止时间戳，null时表示不锁定
    universalType?: boolean // 是否为通用地址 false-否 true-是
    transferMode?: number // 转账模式 1-链上提现 2-内部转账
    addressType?: number // 地址类型 0-链上地址 1-邮箱 2-手机号码 3-UID
    areaCode?: string // 手机号码区号
  }[]
}>
export const postCapitalWithdrawAddressList = (params?: TPostCapitalWithdrawAddressListParams) => {
  return hcAxios.post<TPostCapitalWithdrawAddressListResponse>(API.CapitalWithdrawAddressList, params)
}

export type TPostCapitalWithdrawAddressRemarkEditParams = {
  id?: number // 地址id
  remark?: string // 地址备注
}
export type TPostCapitalWithdrawAddressRemarkEditResponse = TResponse<any>
export const postCapitalWithdrawAddressRemarkEdit = (params?: TPostCapitalWithdrawAddressRemarkEditParams) => {
  return hcAxios.post<TPostCapitalWithdrawAddressRemarkEditResponse>(API.CapitalWithdrawAddressRemarkEdit, params)
}

export type TGetFinanceAirdropLogListParams = {
  coinId?: any // 查询条件 币种id
  count?: any // 是否返回总记录数，默认true
  endTime?: any // 结束时间
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  srcTypes?: any // 类型(9-创新区解冻、10-创新区分红、12-创新区分红奖励、21-空投糖果、23-发红包、24-收红包、25-退还红包、26-扣除红包、40-代理商佣金、60-手工充值、61-带单分润、62-合约自返佣、70-IGO申购、71-IGO分发、72-NFT购买、73-NFT出售、74-NFT手续费、75-NFT版权费、80-Startup认购、81-Startup分发、82-双币理财申购、83-双币理财回款、84-体验金收益)
  startTime?: any // 开始时间
  timeRange?: any // 查询条件 时间范围(0：自定义时间，1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceAirdropLogListResponse = TResponse<any[]>
export const getFinanceAirdropLogList = (params?: TGetFinanceAirdropLogListParams) => {
  return hcAxios.get<TGetFinanceAirdropLogListResponse>(API.FinanceAirdropLogList, { params })
}

export type TGetFinanceTransferHistoryListParams = {
  coinId?: any // 查询条件 币种id
  count?: any // 是否返回总记录数，默认true
  endTime?: any // 结束时间戳
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  sourceWallet?: any // 来源账户 2-现货钱包 3-C2C钱包 5-合约钱包 6-全仓杠杆钱包 7-逐仓杠杆钱包
  startTime?: any // 开始时间戳
  status?: any // 划转状态 1划转成功 2待审核 3审核通过 4审核驳回
  targetWallet?: any // 目标账户 2-现货钱包 3-C2C钱包 5-合约钱包 6-全仓杠杆钱包 7-逐仓杠杆钱包
  timeRange?: any // 查询条件 时间范围(0：自定义时间，1：一周内，2：一月内，3：三月内)
  tradeId?: any // 交易对id
  transferType?: any // 查询条件 划转类型(30-币币至合约、31-合约至币币、37-币币至OTC、36-OTC至币币、34-币币至认购、35-认购至币币、50-币币至逐仓杠杆、51-逐仓杠杆至币币、52-币币至全仓杠杆、53-全仓杠杆至币币)
}
export type TGetFinanceTransferHistoryListResponse = TResponse<
  {
    createdTime?: number // 创建时间
    id?: number // 记录ID
    quantity?: string // 数量
    shortName?: string // 币种
    sourceWallet?: number // 来源账户 2-现货钱包 3-C2C钱包 5-合约钱包 6-全仓杠杆钱包 7-逐仓杠杆钱包
    status?: number // 划转状态 1划转成功 2待审核 3审核通过 4审核驳回
    targetWallet?: number // 目标账户 2-现货钱包 3-C2C钱包 5-合约钱包 6-全仓杠杆钱包 7-逐仓杠杆钱包
    tradeId?: number // 交易对ID
    tradeName?: string // 交易对名称
    transferType?: number // 类型(30-币币至合约、31-合约至币币、34-币币至认购、35认购至币币、36-OTC至币币、37-币币至OTC、50-币币至逐仓杠杆、51-逐仓杠杆至币币、52-币币至全仓杠杆、53-全仓杠杆至币币)
  }[]
>
export const getFinanceTransferHistoryList = (params?: TGetFinanceTransferHistoryListParams) => {
  return hcAxios.get<TGetFinanceTransferHistoryListResponse>(API.FinanceTransferHistoryList, { params })
}

export type TGetWalletTransferTypesParams = any
export type TGetWalletTransferTypesResponse = TResponse<any>
export const getWalletTransferTypes = (params?: TGetWalletTransferTypesParams) => {
  return hcAxios.get<TGetWalletTransferTypesResponse>(API.WalletTransferTypes, { params })
}

export type TGetTransferGetTypeParams = {
  coinId?: any // 币种ID
  currency?: any // 币种名称，比如BTC
  isActivateContract?: any
  isActivateMargin?: any
  targetWallet?: any // 目标账户
  userId?: any
}
export type TGetTransferGetTypeResponse = TResponse<
  {
    sourceWallet?: number // 来源账户
  }[]
>
export const getTransferGetType = (params?: TGetTransferGetTypeParams) => {
  return hcAxios.get<TGetTransferGetTypeResponse>(API.TransferGetType, { params })
}

export type TGetWalletTransferInfosParams = {
  coinId?: any // 币种id
}
export type TGetWalletTransferInfosResponse = TResponse<
  {
    available?: string // 可用余额
    isActivate?: number // 是否开通(合约和划转账户) 0:未开通, 1:已开通
    walletAccount?: number // 钱包账户类型
  }[]
>
export const getWalletTransferInfos = (params?: TGetWalletTransferInfosParams) => {
  return hcAxios.get<TGetWalletTransferInfosResponse>(API.WalletTransferInfos, { params })
}

export type TGetV1WalletTransferTypesParams = {
  coinId?: any // 币种ID
  currency?: any // 币种名称，比如BTC
  isActivateContract?: any
  isActivateMargin?: any
  targetWallet?: any // 目标账户
  userId?: any
}
export type TGetV1WalletTransferTypesResponse = TResponse<
  {
    sortId?: number // 可划转排序ID，1-支持划转 2-不支持划转
    transferTypes?: {
      sourceActivated?: boolean // 来源钱包类型激活状态
      sourceWallet?: number // 来源钱包类型（1-杠杆钱包 2-币币钱包 3-OTC钱包 4-IEO钱包 5-永续合约钱包 6-杠杆全仓钱包 7-逐仓杠杆钱包 8-交割合约）
      targetActivated?: boolean // 目标钱包类型激活状态
      targetWallet?: number // 目标钱包类型（1-杠杆钱包 2-币币钱包 3-OTC钱包 4-IEO钱包 5-永续合约钱包 6-杠杆全仓钱包 7-逐仓杠杆钱包 8-交割合约）
      transferType?: number // 划转类型(30-币币至合约、31-合约至币币、37-币币至OTC、36-OTC至币币、34-币币至认购、35-认购至币币、50-币币至逐仓杠杆、51-逐仓杠杆至币币、52-币币至全仓杠杆、53-全仓杠杆至币币)
    }[] // 划转类型
    walletType?: {
      activated?: boolean // 激活状态 true-已激活 false-未激活，默认激活
      available?: string // 可用余额
      walletType?: number // 钱包类型（1-杠杆钱包 2-币币钱包 3-OTC钱包 4-IEO钱包 5-永续合约钱包 6-杠杆全仓钱包 7-逐仓杠杆钱包 8-交割合约）
    }
  }[]
>
export const getV1WalletTransferTypes = (params?: TGetV1WalletTransferTypesParams) => {
  return hcAxios.get<TGetV1WalletTransferTypesResponse>(API.V1WalletTransferTypes, { params })
}

export type TGetFinanceRechargeLogListParams = {
  coinId?: number // 查询条件 币种id
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  timeRange?: number // 查询条件 时间范围(1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceRechargeLogListResponse = TResponse<
  {
    time: number
    coinId: number
    coinShortName: string
    networkName: string
    type: number
    quantity: string
    status: number
    rechargeAddress: string
    addressTag?: any
    blockChainTradeId: string
    fee: string
    walletDealTime: number
    explorerUrl: string
    addressUrl: string
    remark: string
    addressType: number
    areaCode: string
    chainName?: string
  }[]
>
export const getFinanceRechargeLogList = (params?: TGetFinanceRechargeLogListParams) => {
  return hcAxios.get<TGetFinanceRechargeLogListResponse>(API.FinanceRechargeLogList, { params })
}

export type TGetFinanceTransferLogListParams = {
  coinId?: number // 查询条件 币种id
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  timeRange?: number // 查询条件 时间范围(1：一周内，2：一月内，3：三月内)
  transferType?: number // 查询条件 划转类型(30-币币至合约、31-合约至币币、37-币币至法币、36-法币至币币、34-币币至认购、35-认购至币币)
}
export type TGetFinanceTransferLogListResponse = TResponse<any[]>
export const getFinanceTransferLogList = (params?: TGetFinanceTransferLogListParams) => {
  return hcAxios.get<TGetFinanceTransferLogListResponse>(API.FinanceTransferLogList, { params })
}

export type TGetFinanceWithdrawLogListParams = {
  coinId?: number // 查询条件 币种id
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  status?: number // 查询条件 提币状态（已完成、已汇出、处理中、失败、已撤销）
  timeRange?: number // 查询条件 时间范围(1：一周内，2：一月内，3：三月内)
}
export type TGetFinanceWithdrawLogListResponse = TResponse<
  {
    time: number
    coinId: number
    coinShortName: string
    networkName: string
    type: number
    quantity: string
    status: number
    withdrawAddress: string
    addressDomain?: any
    addressTag?: any
    blockChainTradeId?: any
    fee: string
    walletDealTime?: any
    explorerUrl: string
    addressUrl: string
    remark: string
    createTime: number
    promptId?: any
    rejectPromptReason?: any
    addressType: number
    areaCode: string
    id: number
  }[]
>
export const getFinanceWithdrawLogList = (params?: TGetFinanceWithdrawLogListParams) => {
  return hcAxios.get<TGetFinanceWithdrawLogListResponse>(API.FinanceWithdrawLogList, { params })
}

export type TGetV2CapitalListWithdrawAddressParams = {
  coinId?: any // 币种id，当为全部时请传0
}
export type TGetV2CapitalListWithdrawAddressResponse = TResponse<
  {
    fadderess?: string // 虚拟币地址
    fcoinid?: number // 虚拟币ID
    fcreatetime?: number // 创建时间
    fid?: number // 主键ID
    fremark?: string // 备注
    fuid?: number // 用户ID
    isCollectFee?: boolean // 是否收取手续费,true，收，false，不收
    memo?: string // 地址标签
    shortName?: string // 简称
    isVerified?: boolean // 是否免认证 false-否 true-是
  }[]
>
export const getV2CapitalListWithdrawAddress = (params?: TGetV2CapitalListWithdrawAddressParams) => {
  return hcAxios.get<TGetV2CapitalListWithdrawAddressResponse>(API.V2CapitalListWithdrawAddress, { params })
}

export type TPostCapitalCreateWithdrawAddressParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalCreateWithdrawAddressResponse = TResponse<any>
export const postCapitalCreateWithdrawAddress = (params?: TPostCapitalCreateWithdrawAddressParams) => {
  return hcAxios.post<TPostCapitalCreateWithdrawAddressResponse>(API.CapitalCreateWithdrawAddress, params)
}

export type TPostWithdrawCancelParams = {
  withdrawId?: number // 提币记录id
}
export type TPostWithdrawCancelResponse = TResponse<any>
export const postWithdrawCancel = (params?: TPostWithdrawCancelParams) => {
  return hcAxios.post<TPostWithdrawCancelResponse>(API.WithdrawCancel, params)
}

export type TGetV2CapitalValidateAddressParams = {
  AccessKeyId?: string // 签名AccessKeyId
  SignatureVersion?: string // 签名SignatureVersion
  SignatureMethod?: string // 签名SignatureMethod
  Timestamp?: string // 签名Timestamp
  Signature?: string // 签名Signature
  tradePwd?: string // 资金密码
  googleCode?: string // google验证码
  phoneCode?: string // 手机验证码
  emailCode?: string // 邮箱验证码
  coinId?: number // 币种id
  withdrawAddr?: string // 提币地址
  memo?: string // 地址标签
  remark?: string // 地址备注
  address?: string
  scene?: number
}
export type TGetV2CapitalValidateAddressResponse = TResponse<{
  platformTransfer?: boolean // 仅当code为200时有效(提示信息，非错误)，是否为平台互转，true为平台互转
}>
export const getV2CapitalValidateAddress = (params?: TGetV2CapitalValidateAddressParams) => {
  return hcAxios.get<TGetV2CapitalValidateAddressResponse>(API.V2CapitalValidateAddress, { params })
}

export type TGetV2CapitalRemoveWithdrawAddressParams = {
  id?: any // 地址id
}
export type TGetV2CapitalRemoveWithdrawAddressResponse = TResponse<any>
export const getV2CapitalRemoveWithdrawAddress = (params?: TGetV2CapitalRemoveWithdrawAddressParams) => {
  return hcAxios.get<TGetV2CapitalRemoveWithdrawAddressResponse>(API.V2CapitalRemoveWithdrawAddress, { params })
}

export type TGetV2CapitalCoinWithdrawInfoParams = {
  coinId?: any // 币种id
}

interface PlatformTransferConfig {
  amountAvailable: string
  withdrawDayLimit: string
  withdrawDayTimesAvailable: number
  networkFee: string
  isWithdraw: boolean
  withdrawMin: string
  withdrawMax: string
  withdrawDayTimes: number
  withdrawDayAvailable: string
  isPercentage: boolean
  withdrawFee: string
}

export interface WithdrawConfig {
  amountAvailable: string
  withdrawDayLimit: string
  networkFee: string
  withdrawWornWord: string
  withdrawMax: string
  withdrawDayTimes: number
  withdrawDayAvailable: string
  withdrawFee: string
  withdrawDayTimesAvailable: number
  isWithdraw: boolean
  withdrawMin: string
  platformTransfer: PlatformTransferConfig
  isPercentage: boolean
}

export type TGetV2CapitalCoinWithdrawInfoResponse = TResponse<WithdrawConfig>

export const getV2CapitalCoinWithdrawInfo = (params?: TGetV2CapitalCoinWithdrawInfoParams) => {
  return hcAxios.get<TGetV2CapitalCoinWithdrawInfoResponse>(API.V2CapitalCoinWithdrawInfo, { params })
}

export type TPostCapitalWithdrawParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalWithdrawResponse = TResponse<{
  address?: string // 提现地址
  addressRemark?: string // 地址备注
  amount?: string // 提现数量
  fee?: string // 手续费
  isVerified?: number // 提币是否免认证 0-否 1-是
  memo?: string // 地址标签
  networkName?: string // 主网
}>
export const postCapitalWithdraw = (params?: TPostCapitalWithdrawParams) => {
  return hcAxios.post<TPostCapitalWithdrawResponse>(API.CapitalWithdraw, params)
}

export type TGetCapitalWithdrawAddressCoinParams = any
export type TGetCapitalWithdrawAddressCoinResponse = TResponse<any>
export const getCapitalWithdrawAddressCoin = (params?: TGetCapitalWithdrawAddressCoinParams) => {
  return hcAxios.get<TGetCapitalWithdrawAddressCoinResponse>(API.CapitalWithdrawAddressCoin, { params })
}

export type TGetListWithdrawCoinParams = any
export type TGetListWithdrawCoinResponse = TResponse<
  {
    fadderess?: string
    fcoinid?: number
    fcreatetime?: number
    fid?: number
    fremark?: string
    fuid?: number
    isCollectFee?: boolean
    memo?: string
    shortName?: string
  }[]
>
export const getListWithdrawCoin = (params?: TGetListWithdrawCoinParams) => {
  return hcAxios.get<TGetListWithdrawCoinResponse>(API.ListWithdrawCoin, { params })
}

export type TGetTransferInfoParams = any
export type TGetTransferInfoResponse = TResponse<{
  transferCoinInfoList?: {
    available?: string // 可用余额
    availableCny?: string // 可用余额折合CNY
    coinId?: number // 币种id
    name?: string // 币种全称
    shortName?: string // 币种简称
    transferInAble?: boolean // 能否转入，默认false不可转入 true可转入
    transferOutAble?: boolean // 能否转出，默认false不可转出 true可转出
    transferPrecision?: number // 划转精度
    webLogo?: string // 币种LOGO
  }[] // 可划转币种
}>
export const getTransferInfo = (params?: TGetTransferInfoParams) => {
  return hcAxios.get<TGetTransferInfoResponse>(API.TransferInfo, { params })
}

export type TGetWalletInfoParams = any
export type TGetWalletInfoResponse = TResponse<{
  available?: string // 可用余额
  hasrealvalidate?: boolean // 是否实名认证，true已实名 false未实名
  rewardProfitIn24H?: string // 24H合约体验金盈利额
  rewardTotalProfit?: string // 合约体验金盈利总额
  todayAvailableLimit?: string // 本日可转
  transferOutDebtMultiple?: string // 杠杆账户可转出负债估值倍数
  transferOpenCardInvalid?: boolean // 开仓券划转失效
}>
export const getWalletInfo = (params?: TGetWalletInfoParams) => {
  return hcAxios.get<TGetWalletInfoResponse>(API.WalletInfo, { params })
}
